import React from 'react'
import PropTypes from 'prop-types'
import { message } from 'antd'
import WrappedModal from '@/components/WrappedModal'
import { updateYingshiDevice } from '@/service/yingshi'
import UpdateYingshiDeviceForm from './UpdateYingshiDeviceForm'

function resolveUpdateError (err) {
  if (typeof err === 'string' && err) return err
  return (
    err?.response?.data?.msg ||
    err?.response?.data?.message ||
    err?.msg ||
    err?.message ||
    '更新设备信息失败'
  )
}

class UpdateYingshiDeviceModal extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    width: PropTypes.number,
    baseProps: PropTypes.object,
    onSuccess: PropTypes.func,
    children: PropTypes.node
  }

  static defaultProps = {
    title: '更新设备信息',
    width: 520,
    baseProps: {}
  }

  handleOk = async (form) => {
    const { baseProps, onSuccess } = this.props
    const { device } = baseProps || {}
    const id = device?.id
    if (id == null || id === '') {
      message.error('设备 ID 缺失，无法更新')
      throw new Error('设备 ID 缺失')
    }
    try {
      const fields = await form.current.validateFields()
      const storeIdNum = Number(fields.storeId)
      const sortNum = Number(fields.sort)
      const imageList = Array.isArray(fields.image) ? fields.image : []
      const imageItem = imageList[0]
      let image = ''
      if (imageItem && imageItem.originFileObj) {
        image = imageItem.originFileObj
      }
      const body = {
        name: (fields.name || '').trim(),
        storeId: Number.isFinite(storeIdNum) ? storeIdNum : 0,
        brand: fields.brand != null ? String(fields.brand).trim() : '',
        location: fields.location != null ? String(fields.location).trim() : '',
        bedNo:
          fields.bedNo == null || fields.bedNo === ''
            ? ''
            : String(fields.bedNo).trim(),
        isPinned: fields.isPinned === true,
        needInference: fields.needInference === true,
        remark: fields.remark != null ? String(fields.remark).trim() : '',
        sort: Number.isFinite(sortNum) ? sortNum : 0,
        notifyPhone:
          fields.notifyPhone != null ? String(fields.notifyPhone).trim() : '',
        image
      }
      Object.keys(body).forEach((key) => {
        const v = body[key]
        if (v == null || v === '') delete body[key]
      })
      await updateYingshiDevice(id, body)
      message.success('设备信息已更新')
      if (typeof onSuccess === 'function') onSuccess()
    } catch (err) {
      if (err?.errorFields) throw err
      message.error(resolveUpdateError(err))
      throw err
    }
  }

  render () {
    const { children, baseProps, title, width } = this.props
    const bp = baseProps || {}
    const formKey = bp.device?.id != null ? String(bp.device.id) : 'new'
    return (
      <WrappedModal
        children={children}
        baseComponent={<UpdateYingshiDeviceForm key={formKey} baseProps={bp} />}
        baseProps={{ ...bp }}
        title={title}
        width={width}
        okText="保存"
        onOk={this.handleOk}
      />
    )
  }
}

export default UpdateYingshiDeviceModal
